import { FC, useState, ReactNode, useEffect } from 'react';

import { Moment } from 'moment';

import FlightResponsiveSearchDrawerItem from '@domain/flight/searchBar/dateSelection/responsiveSearchDrawerItem/ResponsiveSearchDrawerItem';
import ResponsiveSearchDrawerItem, {
  ResponsiveDrawerInterface,
} from '@components/views/components/listing/drawer/ResponsiveSearchDrawerItem';
import HotelResponsiveSearchDrawerItem from '@domain/hotel/searchBar/dateSelection/responsiveSearchDrawerItem/ResponsiveSearchDrawerItem';
import CarRentalMobilDateSelect from '@domain/carRental/searchBar/home/dateSelection/dateSelect/mobilDateSelect';
import Drawer from '@components/Drawer';
import { SearchBarPopoverProps } from '@components/ui/search/SearchBarInput/SearchBarInputInterface';

import { ResponsivePickerContent } from './ResponsiveSearchInputDrawerStyle';

type InputComponentsType =
  | 'shopAndFlyHomePageCarRental'
  | 'shopAndFlyHomePageFlight'
  | 'shopAndFlyHomePageHotel'
  | 'setur';

const InputComponents = {
  shopAndFlyHomePageCarRental: CarRentalMobilDateSelect,
  shopAndFlyHomePageFlight: FlightResponsiveSearchDrawerItem,
  shopAndFlyHomePageHotel: HotelResponsiveSearchDrawerItem,
  setur: ResponsiveSearchDrawerItem,
};

const ResponsiveSearchInputDrawer: FC<
  Omit<ResponsiveDrawerInterface, 'onClick'> & {
    drawerTitle?: string;
    inputComponent:
      | 'shopAndFlyHomePageCarRental'
      | 'shopAndFlyHomePageFlight'
      | 'shopAndFlyHomePageHotel'
      | 'setur';
    startDate?: Moment | null;
    endDate?: Moment | null;
    isSubmit?: boolean;
    error?: boolean;
    footerCanGrow?: boolean;
    onFocusChange?: (input: 'startDate' | 'endDate') => void;
  } & {
    children: (child: () => void) => ReactNode;
  } & { popoverProps?: SearchBarPopoverProps }
> = ({
  children,
  inputComponent,
  drawerTitle,
  popoverProps,
  onFocusChange,
  footerCanGrow = false,
  ...otherProps
}) => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  const ResponsiveSearchDrawerItemComponent =
    InputComponents[inputComponent as InputComponentsType];

  const hideModal = () => {
    setIsShowModal(false);
  };

  useEffect(() => {
    if (popoverProps && popoverProps?.isOpen) {
      setIsShowModal(true);
      popoverProps?.onVisibleChange?.(false);
    }
  }, [popoverProps?.isOpen]);

  return isShowModal ? (
    <Drawer title={drawerTitle} open={isShowModal} onClose={hideModal}>
      <ResponsivePickerContent $footerCanGrow={footerCanGrow}>
        {children && children(hideModal)}
      </ResponsivePickerContent>
    </Drawer>
  ) : (
    <ResponsiveSearchDrawerItemComponent
      {...otherProps}
      onFocusChange={onFocusChange}
      onClick={() => setIsShowModal(true)}
    />
  );
};

export default ResponsiveSearchInputDrawer;
